module.exports = __webpack_public_path__ + "img/66.b2ce1c2e.png";